import { ajaxPostJson, ajaxGetJson } from './ajax';
import url from './url'

//用户登录
export const userLoginAjax = (params) => {
  return ajaxPostJson(`/user/login`, params, 'BaseApi3');
};

// 验证邮箱验证码
export const validationEmail = (params) => {
  return ajaxPostJson(`/user/verifySmsCode`, params, 'BaseApi3');
};

//邮箱注册
export const registerAccount = (params) => {
  return ajaxPostJson(`/user/userRegisterEmailNoCode`, params, 'BaseApi3');
};

//邮箱登录
export const loginAccount = (params) => {
  return ajaxPostJson(`/user/loginByEmailAndPwd`, params, 'BaseApi3')
};

//重置密码验证邮箱
export const verifyRegistered = (params) => {
  return ajaxPostJson(`/user/verifySmsCodeUpdatePwd`, params, 'BaseApi3')
};

//重置密码
export const resetPasswords = (params) => {
  return ajaxPostJson(`/user/updateEmailPwd`, params, 'BaseApi3')
};

//退出
export const logoutAjax = (params) => {
  return ajaxPostJson(`${url.LOGOUT}`, params, 'BaseApi3')
};

//获取当前用户信息
export const userInfoAjax = (params) => {
  return ajaxPostJson(`${url.USERINFO}`, params)
};
/**
* 新登录---验证验证码
* @param {
* loginPhone:String  登录电话号码
* verificationCode:String  验证码
* } params
*/
export const loginPhoneCode = (params) => {
  return ajaxPostJson(`/user/iphoneLoginOrRegister`, params, 'BaseApi3');
};
/**
* 新登录---验证验证码，没有注册
* @param {
* loginPhone:String  登录电话号码
* verificationCode:String  验证码
* } params
*/
export const loginPhone = (params) => {
  return ajaxPostJson(`/user/iphoneLogin`, params, 'BaseApi3');
};

/** 新注册 */
/**
 * 验证验证码
 * @param {
 * loginPhone:String  注册号码
 * verifyCode:String  验证码
 * } params
 */
export const verifyPhoneCode = (params) => {
  return ajaxPostJson(`/user/verifyPhoneCodeUndel`, params, 'BaseApi3');
};

/**
 * 手机发送验证码
 * @param {
 * loginPhone:String    电话号码
 * mustNotExist:Boolean 状态
 * } params 
 */
export const registerUserAccount = (params) => {
  return ajaxPostJson(`/user/send_verifyCode`, params, 'BaseApi3');
};

/**
 * 发送邮箱验证码
 * @param {
 * email:String 邮箱
 * mustNotExist:Boolean 状态
 * }params
 */
export const registerEmailAccount = (params) => {
  return ajaxPostJson(`/user/send_email_code`, params, 'BaseApi3');
};

/**
 * 手机号注册用户设置密码
 * @param {
 * loginPhone:String        注册电话号码
 * verificationCode:String  验证码
 * password:String          密码
 * } params
 */
export const userRegisterTelephone = (params) => {
  return ajaxPostJson(`/user/user_register_telephone`, params, 'BaseApi3');
};

/**
 * 邮箱注册用户设置密码
 * @param {
 * email:String             注册电话号码
 * verificationCode:String  验证码
 * password:String          密码
 * } params
 */
export const userRegisterEmail = (params) => {
  return ajaxPostJson(`/user/user_register_email`, params, 'BaseApi3');
};

/** 新重置密码 */
/**
 * 手机重置密码
 * @param {
 * loginPhone:String
 * verificationCode:String
 * password:String
 * } params
 */
export const forgetPonePassword = (params) => {
  return ajaxPostJson(`/user/forgetPassword`, params, 'BaseApi3');
};

/**
 * 邮箱重置密码
 * @param {
 * email:String
 * verificationCode:String
 * password:String
 * } params 
 */
export const forgetEmailPassword = (params) => {
  return ajaxPostJson(`/user/updateEmailPwd`, params, 'BaseApi3');
};

/**
 * 校验手机号是否存在
 * @param {
 * phone:String
 * } params 
 */
export const checkPhone = (params) => {
  return ajaxGetJson(`/user/check_phone_is_flag?phone=${params}`, params, "BaseApi3");
};

/**
 * 校验邮箱是否存在
 * @param {
 * email:String
 * } params 
 */
export const checkEmail = (params) => {
  return ajaxGetJson(`/user/check_email_is_flag?email=${params}`, params, "BaseApi3");
};
